module.exports = "<v-report-table class=flex [report]=report [loading]=widget.loading [clickable]=false [hideFilterBar]=true></v-report-table> ";